//@ts-ignore

export namespace HoverCTA {
	let setupHoverCTA = () => {

        let isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        let isSmallScreen = window.matchMedia("(max-width: 767px)").matches;

        if ( isTouchDevice() || isSmallScreen ){
            // Mobile nav expand/collapse operation
	        let hoverToggles = document.querySelectorAll('.js-hover-cta-toggle');
			let hoverContainers = document.querySelectorAll('.js-hover-container');

            hoverToggles.forEach(function(hoverToggle) {
				hoverToggle.addEventListener('click', e => {
                    e.preventDefault();
					e.stopPropagation();

                    let parent = hoverToggle.closest('.js-hover-container');

                    if(parent.classList.contains('cta-visible')) {
                        parent.classList.remove('cta-visible');
                    } else {
                        parent.classList.add('cta-visible');
                    }
                })
            });

            hoverContainers.forEach(function(hoverContainer){
				hoverContainer.addEventListener('click', e => {
                    // for touch, be sure desc is visible before we link
                    if (hoverContainer.classList.contains('cta-visible')){
                        let clickLink = hoverContainer.getAttribute('href');
                        window.location.href = clickLink;
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        hoverContainer.classList.add('cta-visible');
                    }
                })
            });
        }
	}

	export const init = () => {
		setupHoverCTA();
	}
}
